import styled from 'styled-components';

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 1rem;
  background-color: ${({ theme }) => theme.colors.grayLight};

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    flex-direction: row;
  }
`;

export const EntryTypeItem = styled.div`
  width: 100%;
  margin: 0.6rem auto 1.2rem auto;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    width: 32%;
  }

  .hefesto-card {
    height: 100%;
    & > .hefesto-card-text-buttons {
      display: flex;
      flex-direction: column;
      height: 100%;

      & > .hefesto-card-text-buttons__description {
        flex-grow: 1;
      }
    }
  }
`;
